import BigNumber from "bignumber.js";

export const decimalPlaces = 2;
export const step = BigNumber(10).pow(-decimalPlaces).toNumber();
